import MedicareCostTable from "./MedicareCostTable";

export default MedicareCostTable;